import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { FinancialAccount } from "@common/types/financialAccount";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { HistoryTransactionDetailsRow } from "../views/historyTransactionDetailsViewConfig";

export const HistoryUpdatedTransactionFinancialAccountCell = ({
    row,
}: CellContext<ViewTableFeatures, HistoryTransactionDetailsRow, unknown>) => {
    const financialAccountId = row.original.financialAccountId;
    const financialAccountName = row.original.resource?.financialAccountName as
        | string
        | undefined;

    const accounts = useFinancialAccounts();

    let financialAccount: FinancialAccount | undefined = accounts?.find(
        (account) => account.id === financialAccountId,
    );

    if (!financialAccount) {
        financialAccount = {
            id: financialAccountId,
            name: financialAccountName ?? "",
        } as FinancialAccount;
    }

    if (!financialAccount) {
        return <ViewTableCell />;
    }

    return (
        <ViewTableCell>
            <AccountCard
                account={financialAccount}
                showType={false}
                iconSize="sm"
            />
        </ViewTableCell>
    );
};
